import styled, { css } from "styled-components";

export const CheckoutPaymentsStyled = styled.div`
    background-color: #fff;
    position: relative;
    top: -10px;
    height: calc(100% + 40px);
    width: 100%;
    max-width: 483px;
    font-family: 'Inter', sans-serif;
    .row {
        padding: 62px 40px;
    }
    .line {
        margin: 24px 0;
        width: 100%;
        height: 1px;
        background-color: #E3E8EF;
    }
    .orders {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-bottom: 10px;
        &:last-child {
            margin-bottom: 0;
        }
    }
`

export const AreaItemStyled = styled.div`
     span {
        font-weight: bold;
        font-size: 14px;
        letter-spacing: 0.5%;
        color: #111729;
    }
`

export const NomenclatureItemStyled = styled.div`
    span {
        font-size: 15px;
        letter-spacing: 0.5%;
        font-weight: 400;
        color: #111729;
    }
`

export const DetailsPaymentsFormStyled = styled.div`
    width: 100%;
    max-width: 668px;
    margin: 0 auto;
    margin-top: 10px;
    .form {
        background-color: #FFFFFF;
        border-radius: 16px;
        padding: 20px 30px;
        .header {
            .title {
                color: #111729;
                font-size: 20px;
                font-weight: 600;
                line-height: 125%;
            }
        }
        .contentAccordionForm {
            padding-top: 20px;
        }
        .rowForm {
            display: flex;
            gap: 25px;
            margin-bottom: 10px;
            &:last-child {
                margin-bottom: 0;
            }
            label {
                color: #111729;
                font-size: 18px;
                line-height: 165%;
            }
        }
    }
`

export const DetailsPaymentsTitle = styled.div`
    color: #111729;
    margin-bottom: 24px;
    font-size: 24px;
    line-height: 125%;
    font-weight: bold;
`

export const WrapperItems = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 24px;
    .item, itemNomenclature {
        display: flex;
        justify-content: space-between;
        color: #8181A5;
        font-size: 16px;
        line-height: 165%;
        &__left {
            display: flex;
            gap: 10px;
            font-size: 16px;
            font-weight: 400;
        }
        &-total {
            color: #282A42;
            margin-left: 10px;
        }
    }

    .itemNomenclature {
        padding-left: 20px;
        display: flex;
        justify-content: space-between;
    }

    .item-title {
        font-size: 16px;
        font-weight: bold;
        color: #8181A5;
    }

    .item__areaPrice {
        color: #8181A5;
    }

    .item__areaTotalPrice {
        color: #282A42;
    }
`

export const Total = styled.div`
    display: flex;
    justify-content: space-between;
    color: #111729;
    font-size: 16px;
    font-weight: 600;
`

const StyledDescription = css`
    font-size: 16px;
    text-align: left;
`

export const StyledDescriptionItem = styled.span`
    ${StyledDescription};

    color: #8181a5;
`

export const StyledFooterRow = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;
`